module.exports = __webpack_public_path__ + "media/images/email/youtube-47b3ae54ab5b05f06b7940e7d1a4a699.svg";